(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/components/header-slide-down-menu/views/header-slide-down-menu.js') >= 0) return;  svs.modules.push('/components/components/header-slide-down-menu/views/header-slide-down-menu.js');
(function(svs, Handlebars) {
_svs=window.svs=window.svs||{};
_cmps=_svs.components=_svs.components||{};
_cmps.header_slide_down_menu=_cmps.header_slide_down_menu||{};
_cmps.header_slide_down_menu.templates=_cmps.header_slide_down_menu.templates||{};
svs.components.header_slide_down_menu.templates.header_slide_down_menu = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "        <div class=\"header-slide-down-menu-box\">\n          <div>Pågående spel</div>\n          <div class=\"visible-sm\">\n            "
    + container.escapeExpression((lookupProperty(helpers,"ui")||(depth0 && lookupProperty(depth0,"ui"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"button",{"name":"ui","hash":{"icon":"close","size":100,"block":false,"transparent":true,"class":"js-slide-down-close"},"data":data,"loc":{"start":{"line":7,"column":12},"end":{"line":7,"column":106}}}))
    + "\n          </div>\n        </div>\n";
},"3":function(container,depth0,helpers,partials,data) {
    return "        Pågående spel\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"header-slide-down-menu-container animate-menu-from-top\">\n    <div class=\"f-bold header-slide-menu-heading\">\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"showInlineCloseButton") : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.program(3, data, 0),"data":data,"loc":{"start":{"line":3,"column":6},"end":{"line":12,"column":13}}})) != null ? stack1 : "")
    + "    </div>\n    <div class=\"header-slide-down-menu-content\">\n\n    </div>\n</div>\n\n<div class=\"header-slide-down-menu-overlay animate-menu-overlay\">\n\n</div>\n";
},"useData":true});
Handlebars.partials['components-components-header_slide_down_menu-header_slide_down_menu'] = svs.components.header_slide_down_menu.templates.header_slide_down_menu;
})(svs, Handlebars);


 })(window);